//axios api
import api from "@/lib/Api";

export const getBrandTypes = async () => {
  try {
    const queryRoute = `/type/getBrandTypes`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getDepartment = async () => {
  try {
    const queryRoute = `/type/departments`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getRoleTypes = async (department_id) => {
  try {
    const queryRoute = `/type/roleTypes`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getRoleType = async (department_id) => {
  try {
    const queryRoute = `/type/roleType?department_id=${department_id}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getTemplateListType = async () => {
  try {
    const queryRoute = `/type/getTemplateListType`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAccessControl = async (department_id) => {
  try {
    const queryRoute = `/type/accessControl?department_id=${department_id}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getControlCategory = async () => {
  try {
    const queryRoute = `/type/getControlCategory`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updateAccessControl = async (acTable) => {
  try {
    const queryRoute = `/type/updateAccessControl`;
    const reqBody = { accessControl: [...acTable] };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAccessControlById = async () => {
  try {
    const queryRoute = `/type/getAccessControlById`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAccessControlByUser = async (id) => {
  try {
    const queryRoute = `/type/getAccessControlUser/${id}`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updateAccessControlUser = async (acTable) => {
  try {
    const queryRoute = `/type/updateAccessControlUser`;
    const reqBody = { accessControlUser: [...acTable] };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const resetAccessControlUser = async (id) => {
  try {
    const queryRoute = `/type/resetAccessControlUser/${id}`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createRoletype = async (body) => {
  try {
    const queryRoute = `/type/createRoleType`;
    const reqBody = { ...body };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
